module.exports = __webpack_public_path__ + "img/coin.91e455d5.svg";